module.exports = __webpack_public_path__ + "static/media/logo.ad61fc35.svg";